import { longDate, today } from "./format";

export const STALE_DAYS = 90;

export function daysBetweenDays(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}

export function relativeDays(date: string | null, today: string): string {
  if (!date) return "noch nie";
  const d = daysBetweenDays(date, today);
  if (d <= 0) return "heute";
  if (d === 1) return "gestern";
  if (d < 60) return `vor ${d} Tagen`;
  const months = Math.round(d / 30);
  if (months < 24) return `vor ${months} Monaten`;
  return `vor ${Math.round(d / 365)} Jahren`;
}

export function isStale(date: string | null, today: string): boolean {
  return date === null || daysBetweenDays(date, today) >= STALE_DAYS;
}

export function groupByDate<T extends { date: string }>(items: T[]): { date: string; items: T[] }[] {
  const out: { date: string; items: T[] }[] = [];
  for (const it of items) {
    const last = out[out.length - 1];
    if (last && last.date === it.date) last.items.push(it);
    else out.push({ date: it.date, items: [it] });
  }
  return out;
}

/** Day heading for a feed: „Heute, 3. November“, „Gestern, 2. November“, else „Dienstag, 28. Oktober“. */
export function dayHeading(day: string, now = new Date()): string {
  const d = daysBetweenDays(day, today(now));
  const [, rest] = longDate(day, now).split(", ");
  if (d === 0) return `Heute, ${rest}`;
  if (d === 1) return `Gestern, ${rest}`;
  return longDate(day, now);
}
